
import { Component, Prop, Vue } from "vue-property-decorator";
import { Candidate, CandidateResult } from "@/lib/model/exam/result";

import DescribeData from "@/views/paper/paper-result-report/component/describe.vue";

enum evaluation {
  "欠佳" = "候选人在回答时发音失误多，表达时难以听清表达内容。候选人有可能存在方言口音或面试时处在环境嘈杂的地方进行面试等情况",
  "中等" = "候选人在回答时发音基本标准，但可能存在调值或难点音(平翘舌音、前后鼻尾音等)不准情况",
  "优秀" = "候选人在回答时的发音准确，吐字清晰，表达流畅",
  "0分" = "候选人未作答或回答过于简短，无法考察普通话能力水平"
}

@Component({
  components: { DescribeData }
})
export default class Mandarin extends Vue {
  @Prop() index!: number;
  connectCode = "";
  @Prop({ type: CandidateResult, default: () => new CandidateResult() })
  all!: CandidateResult; //候选人信息 所有表
  @Prop({ type: Candidate, default: () => new Candidate() })
  candidate!: CandidateResult; //候选人信息 主表

  // 评价
  get getEval() {
    const mark = this.all.chineseAssessmentResult.prScore;
    if (mark === 0) {
      return { isEmpty: true, text: evaluation["0分"] };
    } else if (
      mark > 0 &&
      mark < this.all.reportShowConfig.iseChineseScorePercentLimit1
    ) {
      return {
        tag: "欠佳",
        color: "#FF4137",
        isEmpty: false,
        text: evaluation["欠佳"]
      };
    } else if (
      mark >= this.all.reportShowConfig.iseChineseScorePercentLimit1 &&
      mark < this.all.reportShowConfig.iseChineseScorePercentLimit2
    ) {
      return {
        tag: "中等",
        color: "#FF9B00",
        isEmpty: false,
        text: evaluation["中等"]
      };
    } else if (
      mark >= this.all.reportShowConfig.iseChineseScorePercentLimit2 &&
      mark <= 100
    ) {
      return {
        tag: "优秀",
        color: "#19C976",
        isEmpty: false,
        text: evaluation["优秀"]
      };
    } else {
      return { isEmpty: true, text: "" };
    }
  }
}
